var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMDocumentos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#2eccb6;}.cls-3{fill:#fff;}.cls-4{fill:#329be6;}.cls-5{fill:#0b5c96;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_documentos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Documentos"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.86,30.4H50.13V23.9H30.72L30,23.32,24.72,18.9H14.12V45.1l7.39-14.48A.37.37,0,0,1,21.86,30.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.28,32.72a.4.4,0,0,0,0,.56L11.62,44.62V21.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.86,30.4H50.13V23.9H30.72L30,23.32,24.72,18.9H14.12V45.1l7.39-14.48A.37.37,0,0,1,21.86,30.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.72,65.72a.4.4,0,0,0,.56,0L49,50H17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "15.7 47.5 51.1 47.5 58.55 32.9 23.15 32.9 15.7 47.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72,33.28.28a.4.4,0,0,0-.56,0L16.6,16.4h9l6,5h20.6a.39.39,0,0,1,.4.4v8.6H62a.4.4,0,0,1,.36.58l-5.92,11.6,9.3-9.3A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.62,49.6a.4.4,0,0,0,.4.4h5l-5.38-5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12,16.4a.4.4,0,0,0-.4.4v4.58l5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.39,50a.4.4,0,0,0,.36-.22l3.67-7.2L49,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62,30.4H52.63V21.8a.39.39,0,0,0-.4-.4H31.63l-6-5h-9l-5,5V44.62L17,50H49l7.42-7.42L62.34,31A.4.4,0,0,0,62,30.4ZM14.12,18.9h10.6L30,23.32l.69.58H50.13v6.5H21.86a.37.37,0,0,0-.35.22L14.12,45.1Zm37,28.6H15.7l7.45-14.6h35.4Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMDocumentos);
export default __webpack_public_path__ + "static/media/m_documentos.a6f442ef96532de63dec5bf0295cfd53.svg";
export { ForwardRef as ReactComponent };